import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "lot-card"
}
const _hoisted_2 = { class: "lot-card-logo" }
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.estateInfo)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: $setup.estateInfo.logoUrl,
            alt: "Estate logo"
          }, null, 8, _hoisted_3)
        ])
      ]))
    : _createCommentVNode("", true)
}